import type {
  FormattedChannel,
  FormattedGetChannelResponse,
  FormattedNotification,
  GetAlertNotificationsResponse,
  GetChannelResponse,
  GetChannelsResponse
} from '@library/types/alerts';
import {
  getSplitDateTime,
  groupAlertsByDate
} from '@library/component-utils/dateTime';

export const transformChannels = (
  response: GetChannelsResponse | undefined
): Array<FormattedChannel> => {
  if (!response) {
    return [];
  }

  return response.data?.map(({ attributes, id }) => ({
    id: Number(id),
    displayName: attributes.name,
    isChannelUnread: attributes.context.unread,
    isUserSubscribed: attributes.context.subscribed
  }));
};

export const transformAlerts = (
  response: GetChannelResponse | undefined
): FormattedGetChannelResponse => {
  if (!response) {
    return {
      alerts: [],
      currentPage: 1,
      totalPages: 0
    };
  }

  return groupAlertsByDate(response);
};

export const transformNotifications = (
  response: GetAlertNotificationsResponse | undefined
): Array<FormattedNotification> => {
  if (!response) {
    return [];
  }

  return response.data.map((notification) => {
    const user = response.included.find(
      (userObj) => userObj.id === String(notification.attributes.source_user_id)
    );

    return {
      acknowledged: notification.attributes.acknowledged,
      id: notification.id,
      imageUrl: `${user?.attributes.image_url}`,
      firstName:
        notification.attributes.source_user_id === 0
          ? 'System'
          : `${user?.attributes?.first_name}`,
      lastName:
        notification.attributes.source_user_id === 0
          ? 'Message'
          : `${user?.attributes?.last_name}`,
      timestamp: getSplitDateTime(notification.attributes.created_at),
      text: `${notification.attributes.metadata?.message_text}`,
      channelName: `${notification.attributes.metadata?.channel_name}`,
      channelId: `${notification.attributes.metadata?.channel_id}`,
      messageId: `${notification.attributes.metadata?.message_id}`,
      type: `${notification.attributes.type}`
    };
  });
};
